export default __webpack_public_path__ + "static/media/repayIcon.dd011baa.svg";